import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import PaymentModal from 'components/PaymentModal/PaymentModal';
import { sendNotification } from 'containers/CouponBuilderV1/utils/sendNotification';

// Import the CSS module styles
import styles from './SendCouponNotificationModal.module.scss';

const SendCouponNotificationModal = ({
    isOpen,
    onClose,
    onConfirm,
    productCode,
    message,
    couponNotificationData,
    dispatch,
}) => {
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [notificationData, setNotificationData] = useState(null);

    useEffect(() => {
        if (isOpen && couponNotificationData?.coupon) {
            setNotificationData({
                ...couponNotificationData.coupon,
            });
        }
    }, [isOpen, couponNotificationData]);

    const handleContinue = () => {
        setShowPaymentModal(true);
    };

    const handlePaymentClose = () => {
        setShowPaymentModal(false);
        // The caller (CouponBuilderV1) is still awaiting confirmPayment() at this
        // point. Backing out of payment must still resolve that promise (as a
        // decline), otherwise the whole publish/draft flow hangs forever.
        if (onClose) onClose();
    };

    const handlePaymentSuccess = async () => {
        try {
            const response = await sendNotification({
                dispatch,
                coupon: notificationData,
                businessInfo: couponNotificationData.businessInfo,
                couponId: couponNotificationData.couponId,
            });

            if (response?.success) {
                setShowPaymentModal(false);
                if (onConfirm) onConfirm(notificationData);
                if (onClose) onClose();
            } else {
                // sendNotification resolved but reported failure. Don't leave the
                // caller's promise dangling — close out and let the wizard
                // continue; the coupon itself has already been created/edited.
                setShowPaymentModal(false);
                if (onClose) onClose();
            }
        } catch (err) {
            console.error('Failed to send notification:', err);
            // Same reasoning: a thrown error here must not orphan the promise
            // that handleFinalSubmit is awaiting via confirmPayment().
            setShowPaymentModal(false);
            if (onClose) onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <Modal
                isOpen={isOpen && !showPaymentModal}
                onRequestClose={onClose}
                title="Send Push Notification"
            >
                {/* Modernized Header/Message area */}
                <div className={styles.modalHeader}>
                    <p className={styles.message}>{message}</p>
                </div>

                {/* Notification Title Input */}
                <div className={styles.formGroup}>
                    <label className={styles.label}>Notification Title</label>
                    <input
                        type="text"
                        className={styles.inputField}
                        placeholder="Enter dynamic notification title..."
                        value={notificationData?.title || ''}
                        onChange={(e) => {
                            const val = e.target.value;
                            setNotificationData((prev) => ({
                                ...prev,
                                title: val,
                            }));
                        }}
                    />
                </div>

                {/* Notification Body Textarea */}
                <div className={styles.formGroup}>
                    <label className={styles.label}>Notification Message</label>
                    <textarea
                        rows={4}
                        className={styles.textareaField}
                        placeholder="Write something compelling for your users..."
                        value={notificationData?.description || ''}
                        onChange={(e) => {
                            const val = e.target.value;
                            setNotificationData((prev) => ({
                                ...prev,
                                description: val,
                            }));
                        }}
                    />
                </div>

                {/* Action Buttons Footer */}
                <div className={styles.modalActions}>   
                    <Button outline onClick={onClose}>
                        Cancel
                    </Button>
                    <Button onClick={handleContinue}>
                        Continue
                    </Button>
                </div>
            </Modal>

            <PaymentModal
                isOpen={showPaymentModal}
                onClose={handlePaymentClose}
                onConfirm={handlePaymentSuccess}
                productCode={productCode}
                message="Purchase Push Notification"
            />
        </>
    );
};

export default connect()(SendCouponNotificationModal);